<template lang="pug">
aside-flatkit(id="product-create", ref="modal", :loading="onLoading('create-product')")
    template(slot="header-text") Create Product
    template(slot="footer")
        button(
            class="md-btn md-raised m-b-sm w-xs green m-l-sm",
            @click="submit"
        )
            v-loading(loader="create-product") Save
    template(slot="body")
        .col-md-12.p-t-md
            form
                fieldset(:disabled="onLoading('create-product')")
                    .form-group
                        label Name
                        input.form-control(
                            name="name",
                            :class="{ 'has-error': errors.has('name') }",
                            v-model="product.name",
                            v-validate="'required'",
                        )
                        span.text-danger(v-if="errors.has('name')")
                            | {{ errors.first('name') }}

                    .form-group
                        label Code
                        input.form-control(
                            v-model="product.code"
                        )
                    
                    .form-group
                        label Sku
                        input.form-control(
                            :class="{ 'has-error': errors.has('sku') }",
                            name="sku",
                            v-model="product.variants[0].sku"
                        )
                        span.text-danger(v-if="errors.has('sku')")
                            | {{ errors.first('sku') }}

                    .form-group
                        label Price
                        input.form-control(
                            name="price",
                            :class="{ 'has-error': errors.has('price') }",
                            v-model="product.variants[0].price"
                            v-validate="'required|decimal:2|min_value:0'",
                        )
                        span.text-danger(v-if="errors.has('price')")
                            | {{ errors.first('price') }}


                    .form-group
                        label Cost
                        input.form-control(
                            :class="{ 'has-error': errors.has('cost') }",
                            name="cost",
                            v-model="product.variants[0].cost",
                            v-validate="'decimal:2|min_value:0'",
                        )
                        span.text-danger(v-if="errors.has('cost')")
                            | {{ errors.first('cost') }}

                    .form-group
                        label Description
                        textarea.form-control(
                            rows="3",
                            v-model="product.description"
                        )
                    
                    .form-group
                        label Tags
                        multiselect(
                            v-model="product.tags",
                            :multiple="true",
                            :hide-selected="true",
                            :close-on-select="false",
                            :options="tagList",
                            track-by="id",
                            label="name",
                            placeholder="Select Tags",
                            select-label="",
                            deselect-label=""
                        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    data() {
        return {
            product: null,
        };
    },

    computed: {
        ...mapGetters('tag', ['tagList']),
    },

    created() {
        this.initProduct();
    },

    mounted() {
        this.$on('show', () => {
            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        ...mapActions('product', ['createProduct']),

        initProduct() {
            this.product = {
                name: null,
                code: null,
                description: null,
                tags: [],
                variants: [
                    {
                        name: 'Regular',
                        cost: null,
                        price: null,
                        sku: null,
                    },
                ],
            };
        },

        async submit() {
            const validate = await this.$validator.validate();

            if (!validate || this.onLoading('create-product')) {
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }

                return;
            }

            this.startLoading('create-product');

            const product = _.pick(this.product, [
                'name',
                'code',
                'sku',
                'description',
                'price',
                'cost',
                'variants',
            ]);

            product.tags = this.product.tags.map(tag => tag.id);

            this.createProduct(product)
                .then(product => {
                    this.endLoading('create-product');
                    this.initProduct();
                    this.$refs.modal.$emit('hide');
                    this.$parent.refresh();
                    this.$router.push(`/${product.id}`);
                })
                .catch(err => {
                    if (this.hasLaravelErrors(err)) {
                        this.processLaravelErrors(
                            this.$validator,
                            err.response,
                        );
                    } else {
                        this.swal({
                            type: 'error',
                            text: err,
                            title: '',
                        });
                    }

                    this.endLoading('create-product');
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-create.vue